import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HealthMentorComponent } from './health-mentor.component';
import { HealthMentorRoutingModule } from './health-mentor.routing.module';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CancelAppointmentModalComponent } from './modals/cancel-appointment-modal/cancel-appointment-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AppointmentsService } from '../../services/scheduling/appointment/appointments.service';
import { CoachingAppointmentComponent } from './coaching-appointment/coaching-appointment.component';
import { PostExamCoachingTileComponent } from './post-exam-coaching-tile/post-exam-coaching-tile.component';

@NgModule({
	imports: [CommonModule, HealthMentorRoutingModule, SharedModule, MaterialModule, ReactiveFormsModule],
	declarations: [
		HealthMentorComponent,
		CancelAppointmentModalComponent,
		CoachingAppointmentComponent,
		PostExamCoachingTileComponent,
	],
	providers: [
		{ provide: MAT_DIALOG_DATA, useValue: {} },
		{ provide: MatDialogRef, useValue: {} },
		{ provide: AppointmentsService, useClass: AppointmentsService },
	],
})
export class HealthMentorModule {}
